import { useCallback, useEffect, useRef, useState } from 'react';
import { ANCHOR_ATTR } from './utils';

/** Tracks the sandboxed iframe's document and keeps in-document (#) links working. */
export const useDocxFrame = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [frameDoc, setFrameDoc] = useState<Document | null>(null);

  const handleFrameLoad = useCallback(() => {
    setFrameDoc(iframeRef.current?.contentDocument ?? null);
  }, []);

  useEffect(() => {
    if (!frameDoc) return;

    const handleClick = (event: MouseEvent) => {
      const link =
        event.target instanceof Element ? event.target.closest('a') : null;
      if (!link) return;
      event.preventDefault();
      const anchor = link.getAttribute(ANCHOR_ATTR);
      if (anchor) {
        frameDoc
          .getElementById(anchor)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    frameDoc.addEventListener('click', handleClick);
    return () => frameDoc.removeEventListener('click', handleClick);
  }, [frameDoc]);

  return { iframeRef, frameDoc, handleFrameLoad };
};
